$(document).ready(function() {
  $(document).on('click', '.clients-momentum-planning-unit-economics-component .unit-economics-section-options .radio-buttons__option', function() {
    const component = $(this).closest('.clients-momentum-planning-unit-economics-component'); // Update yes-no radio button values back to section
    const id = component.attr('momentum_unit_economics_section_id'); // Id of the section
    const property = $(this).attr('attr'); // Which radio is getting clicked
    const value = $(this).attr('value'); // Value of the radio button
    updateUnitEconomicsSection(id, property, value);
  });

  function updateUnitEconomicsSection(id, property, value) {
    $.post('/components/clients/momentum_sections/unit_economics', { id: id, property: property, value: value }).done(function(data) {

      if (data.success) {
        window.reloadConfirmationDayReadinessAssessmentComponent();
        window.reloadMomentumSectionPlanningTab(data.section_completion_percentage, 'unit_economics');
        window.reloadClientTaskBinComponents();
      }
    });
  }
});
